import portalApi from './axios/portalAxios';

export const getSubjects = (categoryId) => {
  return portalApi.get('/subjects', { params: { category_id: categoryId } });
};

export const getEduLevelSubjects = () => {
  return portalApi.get('/edu-level-subjects');
};

export const getMediums = () => {
  return portalApi.get('/mediums');
};

export const getCities = () => {
  return portalApi.get('/cities');
};

export const getDistrictCities = () => {
  return portalApi.get('/district-cities');
};

export const getClassTypes = () => {
  return portalApi.get('/class-types');
};

export const getSubjectCategories = () => {
  return portalApi.get('/subject-categories');
};
